import React from 'react';
import { Button, Select, MenuItem, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

const ThemeDialog = ({ 
    open, 
    kioskThemes, 
    customKioskThemeID, 
    setCustomKioskThemeID,
    onConfirm,
    onCancel
}) => {
    return (
        <Dialog open={open}>
            <DialogTitle>Reset Custom Theme</DialogTitle>
            <DialogContent>
                <Typography>
                    Choose the theme you want to use as a starting point. You can then customise the theme images, colours and even the CSS code.
                </Typography>
                <FormControl variant="filled" fullWidth>
                    <InputLabel id="theme-label">Custom kiosk theme starting point</InputLabel>
                    <Select
                        value={customKioskThemeID}
                        onChange={(e) => setCustomKioskThemeID(e.target.value)}
                        label="Custom kiosk theme starting point"
                        labelId="theme-label"
                        name="CustomKioskThemeID"
                        required
                    >
                        {kioskThemes.map((theme) => (
                            theme.shortName !== 'custom' && (
                                <MenuItem key={theme.id} value={theme.id}>
                                    {theme.name}
                                </MenuItem>
                            )
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button disabled={!customKioskThemeID} onClick={onConfirm}>Proceed</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ThemeDialog;

